module.exports = __webpack_public_path__ + "img/play-btn.449eeff2.png";